import Modeling from "bpmn-js/lib/features/modeling/Modeling";
import colors from "shared/styles/colors";

export default class PopupMenuProvider {
    private modeling: Modeling;

    constructor(popupMenu: any, modeling: Modeling) {
        this.modeling = modeling;
        popupMenu.registerProvider("color-picker", this);
    }

    public getEntries = (element: any) => {
        const colorEntries = [
            {
                label: "Red",
                hex: colors.warningSecondary
            }, {
                label: "Orange",
                hex: colors.orangeSecondary
            }, {
                label: "Green",
                hex: colors.greenSecondary
            }, {
                label: "Blue",
                hex: colors.blueSecondary
            }, {
                label: "Purple",
                hex: colors.purpleSecondary
            }, {
                label: "Pink",
                hex: colors.pinkSecondary
            }
        ];

        const entries = colorEntries.map((color) => {
            return {
                label: color.label,
                id: color.label.toLowerCase() + "-color",
                className: "color-icon-" + color.label,
                action: this.createAction(this.modeling, element, color.hex)
            };
        });
        const entriesWithClearColor = [
            {
                label: "Clear",
                id: "clear-color",
                className: "color-icon-clear",
                action: this.createAction(this.modeling, element)
            },
            ...entries
        ]
        return entriesWithClearColor;
    }

    private createAction = (modeling: Modeling, element: any, newColor?: any) => {
        // set hex value to an element
        return () => {
            modeling.setColor(element, {
                fill: newColor
            });
        };
    }

}
PopupMenuProvider.$inject = [
    "popupMenu",
    "modeling"
];
